export default "__VITE_ASSET__1L_P6UR___"